import { Skeleton } from "@chakra-ui/react";
import { NavBar } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";
import { useClientNavigationPages } from "./hooks";

interface NavigationClientProps {
  id: string;
  variant?: "page" | "panel";
}

const NavigationClient = ({ id, variant = "panel" }: NavigationClientProps) => {
  const { isDesktop } = useScreenType();
  const { visiblePages, data, activePage } = useClientNavigationPages(id);

  if (variant === "page") {
    return (
      <AppSubNav showWidgets={false} zIndex="1">
        {visiblePages.map((page) => (
          <NavBar.Item key={page.href.pathname} href={page.href}>
            {page.title()}
          </NavBar.Item>
        ))}
      </AppSubNav>
    );
  }

  return (
    <AppSubNav>
      <NavBar.Item href="/clients" active={false}>
        <Trans>Clients</Trans>
      </NavBar.Item>
      {isDesktop && <Icon name="chevron-right" />}

      <NavBar.Item
        href={{ pathname: "/clients/detail", query: { id } }}
        active={false}
      >
        <Skeleton isLoaded={!!data}>{data?.name ?? t`Detail`}</Skeleton>
      </NavBar.Item>

      {isDesktop && activePage && <Icon name="chevron-right" />}

      {activePage && (
        <NavBar.Item href={activePage.href} active={false}>
          {activePage.title()}
        </NavBar.Item>
      )}
    </AppSubNav>
  );
};

export default observer(NavigationClient);
